module.exports = __webpack_public_path__ + "static/Topland_blue-74487d40a0297b712e039449fcaad0cb.png";